import { render, staticRenderFns } from "./personStatistics.vue?vue&type=template&id=9bab2772&scoped=true"
import script from "./personStatistics.vue?vue&type=script&lang=js"
export * from "./personStatistics.vue?vue&type=script&lang=js"
import style0 from "./personStatistics.vue?vue&type=style&index=0&id=9bab2772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bab2772",
  null
  
)

export default component.exports